export type ThemePreference = "dark" | "light"
export type ThemedValue<T> = {
  [key in ThemePreference]: T
}
export type NoChildren<P> = Omit<P, "children">
export interface AcceptsChildren {
  children?: React.ReactNode
}
